// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"style__messageBox__Gcdlw"};